import React from "react";
import Dictionary from "./Dictionary";
import { MagnifyingGlass } from "react-loader-spinner";

import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <h1>
          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            ariaLabel="MagnifyingGlass-loading"
            wrapperStyle={{}}
            wrapperClass="MagnifyingGlass-wrapper"
            glassColor="#f2baba"
            color="#000000"
          />
        </h1>
        <h1>Dictionary App</h1>
        <p>The world is your oyster!</p>
        <Dictionary />
      </div>
      <br></br>
      <footer>
        <a
          href="https://github.com/ApocalypseAnt/weatherapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open-source code
        </a>
        , by{" "}
        <a href="https://www.shecodes.io/graduates/25254-ana-martins">
          Ana Martins
        </a>
      </footer>
    </div>
  );
}
